import { BaseDao } from './BaseDao';
import { Observable } from 'rxjs';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { User } from '../../models/user';
import { HttpHeaders } from '@angular/common/http';

export class UserDao extends BaseDao {
  static PATHS = {
    FORGOT_PASSWORD: '/forgot-password/',
    RESET_PASSWORD: '/reset-password/'
  };
  private currentUser: User;
  public triggerCollapseState = {
    kantar: true,
    'kantar-product': true,
    custom: true,
    'vidvita-radio': true,
    weather: true,
    nlp: true,
    'kinetiq-acr': true
  };
  public triggerFilterState = {
    kantar: 'active',
    'kantar-product': 'active',
    custom: 'active',
    'vidvita-radio': 'active',
    weather: 'active',
    nlp: 'active',
    'kinetiq-acr': 'active'
  };

  public actionListViewType = 'summary';

  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.USER, apiHelper);
  }

  public getCurrentUser(): User {
      return this.currentUser;
  }

  public setCurrentUser(currentUser: User): void {
    this.currentUser = currentUser;
    if(this.currentUser && this.currentUser.id && window['hj']) {
      (window as any).hj('identify', this.currentUser.id.toString(), {
        email: this.currentUser.email,
        timezone: this.currentUser.timezone,
        isAdmin: this.currentUser.isAdmin
      });
    }
  }

  public createFromInvite(user: User, inviteId: string): Observable<User> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/create-from-invite/' + inviteId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, { user: user }, headers, null);
  }

  public updateWithPassword(user: User, pass): Observable<User> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/withPass/' + user.id;
    let headers = this.apiHelper.getDefaultHeader();
    let data: any = user;
    delete data.$type;
    if (pass) {
      data.password = pass;
    }
    return this.apiHelper.apiCall<User>(url, 'PUT', null, data, headers, null);
  }

  public updateUser(user: User, roleIds: number[], brandIds: string[] = null): Observable<User> {
    let url: string = this.apiHelper.getServiceName() + this.getResource() + '/' + user.id;
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    let data: Object = {
      id: user.id,
      email: user.email,
      password: user.password,
      firstName: user.firstName,
      lastName: user.lastName,
      termsAccepted: user.termsAccepted,
      isAdmin: user.isAdmin,
      agencies: user.agencies,
      advertisers: user.advertisers,
      brands: user.brands,
      timezone: user.timezone,
      disabled: user.disabled,
      bvsOnly: user.bvsOnly
    };
    data['roles'] = roleIds;
    if (brandIds) data['brands'] = brandIds;
    return this.apiHelper.apiCall<User>(url, 'PUT', null, data, headers, null);
  }

  public createUser(user: User, roleIds: number[]): Observable<User> {
    let url: string = this.apiHelper.getServiceName() + this.getResource() + '/';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let userData = user as any;
    userData.roles = roleIds;
    return this.apiHelper.apiCall<User>(url, 'POST', null, userData, headers);
  }

  public requestEmail(email: string, currentUrl: string): Observable<User> {
    let url: string = this.apiHelper.getServiceName() + this.getResource() + UserDao.PATHS.FORGOT_PASSWORD;
    let dataObj: Object = {
      email: email,
      url: currentUrl
    };

    return this.apiHelper.apiCall(url, 'POST', null, dataObj, null);
  }

  public getResettingUser(resetPasswordToken: string): Observable<User> {
    let url = this.apiHelper.getServiceName() + this.getResource() + UserDao.PATHS.RESET_PASSWORD + resetPasswordToken;
    return this.apiHelper.apiCall(url, 'GET', resetPasswordToken, null, null);
  }

  public updateAndLogin(id: number, resetPasswordToken: string, password: string): Observable<User> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + UserDao.PATHS.RESET_PASSWORD + resetPasswordToken;
    let params = [id, resetPasswordToken, password];
    let data: Object = {
      id: id,
      password: password
    };

    return this.apiHelper.apiCall(url, 'PUT', params, data, null);
  }

  public acceptTerms(): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/acceptTerms';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'PUT', null, null, headers);
  }

  public checkEmail<T>(desiredEmail: string): Observable<T> {
    let url: string = this.apiHelper.getServiceName() + this.getResource() + '/';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    let dataBody = {
      name: desiredEmail
    };

    return this.apiHelper.apiCall<T>(url, 'POST', null, dataBody, headers, 'checkname', false);
  }

  public updateTimezone(id: string, timezone: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/timezone';
    let headers = this.apiHelper.getDefaultHeader();
    let data = {
      id,
      timezone
    };
    this.currentUser.timezone = timezone;
    return this.apiHelper.apiCall(url, 'POST', null, data, headers);
  }

  public activate(userId: string): Observable<boolean> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/activate/' + userId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'PUT', null, null, headers);
  }

  public deactivate(userId: string): Observable<boolean> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/deactivate/' + userId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'PUT', null, null, headers);
  }

  public checkPassword(user: any): Observable<boolean> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/check-password'
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, user, headers);
  }

  public updateDetails(id: string, updates: any): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + `/${id}/details`
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'PUT', null, updates, headers);
  }

  public findUsersByAdvertiser(advertiserId: string): Observable<User[]> {
    let url = this.apiHelper.getServiceName() + this.getResource() + `/advertiser/${advertiserId}`;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }

  public findById(id: string): Observable<User> {
    let url = this.apiHelper.getServiceName() + this.getResource() + `/${id}`;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }
}
